import DynamicSvg from './CodexLoader';
import { v4 as uuid } from 'uuid';
import { twMerge } from 'tailwind-merge';
import React from 'react';
import { useSpinDelay } from 'spin-delay';

interface ILoader {
  testID?: string;
  className?: string;
}

const Loader: React.FC<ILoader> = ({ testID, className }) => {
  const maskId = uuid();
  return (
    <div
      className="flex flex-col items-center justify-center"
      data-testid={testID}
    >
      <div
        className={twMerge(
          'desktop:w-[240px] desktop:h-[240px] w-[160px] h-[160px] relative',
          className,
        )}
      >
        <DynamicSvg maskId={maskId} />
      </div>
    </div>
  );
};

export default Loader;

export const FullPageLoader = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-transparent pointer-events-none">
      <Loader />
    </div>
  );
};

export const FallbackLoader = () => {
  const show = useSpinDelay(true, { delay: 200, minDuration: 500 });
  if (!show) return null;
  return <FullPageLoader />;
};
